import { useEffect, useState } from "react";
import { Building2, ClipboardList, CreditCard, Users } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function PlatformOverviewPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);

    api
      .get("/platform/overview")
      .then((r) => setData(r.data))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const cards = [
    {
      label: "Tenants",
      value: data?.tenants ?? 0,
      icon: Building2,
    },
    {
      label: "Users",
      value: data?.users ?? 0,
      icon: Users,
    },
    {
      label: "Orders",
      value: data?.orders ?? 0,
      icon: ClipboardList,
    },
    {
      label: "Plans",
      value: data?.plans ?? 0,
      icon: CreditCard,
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Platform Overview</h1>
        <p className="text-sm text-muted-foreground">
          Ringkasan kondisi GLOO POS secara keseluruhan.
        </p>
      </div>

      {loading ? (
        <div className="text-sm text-muted-foreground">
          Memuat data platform...
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map((card) => {
            const Icon = card.icon;

            return (
              <div
                key={card.label}
                className="rounded-xl border bg-card p-5 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-muted-foreground">
                      {card.label}
                    </p>
                    <p className="mt-2 text-3xl font-bold">
                      {card.value}
                    </p>
                  </div>

                  <div className="rounded-lg border p-3">
                    <Icon className="h-5 w-5" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="rounded-xl border bg-card p-5">
        <h2 className="font-semibold">Founder Control Center</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Gunakan menu di bagian atas untuk mengelola owner, subscription,
          dan plan GLOO POS.
        </p>
      </div>
    </div>
  );
}
